export class CalculateTracking {
  sessionID?: string;
  requestID?: string;

  constructor(sessionID: string, requestID: string) {
    this.sessionID = sessionID;
    this.requestID = requestID;
  }
}
